
<script setup lang="ts">

import { useBackButton } from "@app/Components/Utilities";

useBackButton();

</script>

<template>

    <div class="bg-white dark:bg-gray-850 tracking-wider text-sm lg:text-base
                 w-full h-full overflow-y-auto flex flex-col pb-12">

        <div class="flex justify-center items-center my-6">
            <strong class="text-lg font-bold">Rego</strong>
        </div>     

        <div class="flex flex-col w-full gap-3 px-4 lg:px-6">
        
            <h1>
                Don’t get caught out with an expired rego. Allowing your car rego 
                to expire can have several significant consequences.
            </h1>
            
            <p>
                Here's why it's important:
            </p>

            <div class="pl-2 lg:pl-4 flex flex-col w-full gap-3 dark:text-gray-300">
            
                <p>
                    <span class="dark:text-white">Legal Compliance:</span> Operating a 
                    vehicle with an expired registration is illegal in most jurisdictions. 
                    If caught driving with an expired rego, you may face fines or penalties.
                </p>

                <p>
                    <span class="dark:text-white">Insurance Coverage:</span> 
                    Many insurance policies require that your vehicle registration is current 
                    for coverage to be valid. If your rego expires and you're involved in 
                    an accident, your insurance company may deny coverage, leaving you 
                    personally responsible for any damages or injuries. This can result in 
                    significant financial hardship and legal liability.
                </p>        

                <p>
                    <span class="dark:text-white">Roadworthiness:</span> In some places, 
                    vehicle registration renewal involves a roadworthiness inspection to 
                    ensure that your car meets safety and emissions standards. Allowing 
                    your rego to expire means your vehicle may not have undergone this 
                    inspection, potentially putting you and other road users at risk if 
                    your car is not roadworthy.
                </p>

            </div>

        </div>

    </div>   
    
</template>
